import { apiClient } from "./ApiClient";

export const retrieveAllShippingInstructionsApi = () =>
  apiClient.get(`/shipment-view/shipping-instructions`);

export const retrieveFastShippingInstructionsApi = () =>
  apiClient.get(`/shipment-view/fast-shipping-instructions`);
export const retrieveFastShippingInstructionCostingApi = () =>
  apiClient.get(`/shipment-view/fast-shipping-instruction-costs`);
export const retrieveFilteredShippingInstructionsApi = (shippingInstruction) =>
  apiClient.post(
    `/shipment-view/shipping-instruction/filter`,
    shippingInstruction,
  );

  export const retrieveFastFilteredShippingInstructionsApi = (shippingInstruction) =>
    apiClient.post(
      `/shipment-view/fast-shipping-instruction/filter`,
      shippingInstruction,
    );

    export const retrieveFastFilteredShippingInstructionCostingApi = (shippingInstruction) =>
      apiClient.post(
        `/shipment-view/fast-shipping-instruction-costs/filter`,
        shippingInstruction,
      );

export const createShippingInstructionApi = (shippingInstruction) =>
  apiClient.post(
    `/shipment-view/shipping-instruction/add`,
    shippingInstruction,
  );
export const createMultipleShippingInstructionsApi = (
  shippingInstructionList,
) =>
  apiClient.post(
    `/shipment-view/shipping-instruction/add-multiple`,
    shippingInstructionList,
  );
export const updateShippingInstructionApi = (
  shippingInstructionId,
  shippingInstruction,
) =>
  apiClient.put(
    `/shipment-view/shipping-instruction/edit/${shippingInstructionId}`,
    shippingInstruction,
  );
export const updateMultipleShippingInstructionsApi = (
  shippingInstructionList,
) =>
  apiClient.put(
    `/shipment-view/shipping-instruction/edit/shipping-instruction-list`,
    shippingInstructionList,
  );
export const deleteShippingInstructionsApi = (shippingInstructionList) =>
  apiClient.put(
    `/shipment-view/shipping-instruction/delete-list`,
    shippingInstructionList,
  );
export const retrieveSelectedShippingInstructionsByIdApi = (
  shippingInstructionIdList,
) =>
  apiClient.post(
    `/shipment-view/shipping-instruction/get-selected`,
    shippingInstructionIdList,
  );
  export const retrieveShippingInstructionByIdApi = (shippingInstructionId) => apiClient.get(`/shipment-view/shipping-instruction/get/${shippingInstructionId}`);

export const retrieveMaxShippingInstructionNumberApi = (siType, currentYear) =>
  apiClient.post(`/shipment-view/shipping-instruction/max-si-number/${siType}`, currentYear);

  export const retrieveTotalStakeholderShippingInstructionsApi = (orderType, year) =>
  apiClient.get(`/shipment-view/shipping-instruction/stakeholder-totals`, {
    params: {
      orderType:   orderType,
      year:     year,
    }
  });